module.exports = __webpack_public_path__ + "img/voice-thumb14.4b50c77.jpg";